const CHAT_ENTRY = {
    global: 'global',
    customerService: 'customerService',
    footer: 'footer',
    resume: 'resume',
    bccPlaceHolderApp: 'customerServiceChatApp',
    fraudErrCheckout: 'fraudErrCheckout',
    authenticate: 'AUTHENTICATED'
};

export { CHAT_ENTRY };
